const metricSystemUnits = {
  cm: {
    value: 1, // in cm (base unit for length)
    n_dim: 1,
    unit_system: 'metric',
  },
  cm2: {
    value: 1, // in cm² (base unit for area)
    n_dim: 2,
    unit_system: 'metric',
  },
  cm3: {
    value: 1, // in cm³ (base unit for volume)
    n_dim: 3,
    unit_system: 'metric',
  },
  ml: {
    value: 100, // 1 linear meter = 100 cm
    n_dim: 1,
    unit_system: 'metric',
  },
  mq: {
    value: 100 * 100, // 10,000 cm² (1 m² = 100 cm * 100 cm)
    n_dim: 2,
    unit_system: 'metric',
  },
  m3: {
    value: 100 * 100 * 100, // 1,000,000 cm³ (1 m³ = 100 cm * 100 cm * 100 cm)
    n_dim: 3,
    unit_system: 'metric',
  },
  // km: {
  //   value: 1000 * 100, // 100,000 cm
  //   n_dim: 1,
  //   unit_system: 'metric_meters',
  // },
  liters: {
    value: 1000, // 1 liter = 1000 cm³
    n_dim: 3,
    unit_system: 'metric',
  },
}

const imperialSystemUnits = {
  inch: {
    value: 2.54, // 1 inch = 2.54 cm
    n_dim: 1,
    unit_system: 'imperial',
  },
  inch2: {
    value: 2.54 * 2.54, // in cm²
    n_dim: 2,
    unit_system: 'imperial',
  },
  inch3: {
    value: 2.54 * 2.54 * 2.54, // in cm³
    n_dim: 3,
    unit_system: 'imperial',
  },
  foot: {
    value: 30.48, // 1 foot = 30.48 cm
    n_dim: 1,
    unit_system: 'imperial',
  },
  foot2: {
    value: 30.48 * 30.48, // in cm²
    n_dim: 2,
    unit_system: 'imperial',
  },
  foot3: {
    value: 30.48 * 30.48 * 30.48, // in cm³
    n_dim: 3,
    unit_system: 'imperial',
  },
  yard: {
    value: 91.44, // 1 yard = 91.44 cm
    n_dim: 1,
    unit_system: 'imperial',
  },
  yard2: {
    value: 91.44 * 91.44, // in cm²
    n_dim: 2,
    unit_system: 'imperial',
  },
  yard3: {
    value: 91.44 * 91.44 * 91.44, // in cm³
    n_dim: 3,
    unit_system: 'imperial',
  },
}

const otherUnits = {
  fixed_price: {
    value: 1,
    n_dim: 0,
    unit_system: null,
  },
  number: {
    value: 1,
    n_dim: 0,
    unit_system: null,
  },
  hour: {
    value: 1,
    n_dim: 0,
    unit_system: null,
  },
}

export const UnitsList = (system) => ({
  ...otherUnits,
  ...system === 'metric' ? metricSystemUnits : imperialSystemUnits,
})

export const AllUnits = { ...metricSystemUnits, ...imperialSystemUnits, ...otherUnits }

export const findUnitByFamilyAndDimension = (unit_system, targetDim) => {
  if (!unit_system) return null

  const unitKey = Object.keys(AllUnits).find(key => AllUnits[key].unit_system === unit_system && AllUnits[key].n_dim === targetDim)
  return unitKey || null
}
